import { Controller } from "@hotwired/stimulus"

// Slide-over drawer for the calculation panel. A fork of catalog_drawer_controller
// with one deliberate difference: it opens ITSELF when its turbo frame finishes
// loading, instead of being opened by a click action on the link.
//
// That matters because the calculation drawer shares a page with other drawers — on
// the Positionskatalog it sits next to the Baustein drawer, and both would otherwise
// be targets of the same catalog-drawer controller instance, whose panelTarget
// resolves to the FIRST match. The link that opens this drawer also lives inside that
// other drawer, so it cannot reach this one through Stimulus action routing at all.
// Reacting to the frame load keeps the two independent.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    this.boundFrameLoad = this.onFrameLoad.bind(this)
    this.element.addEventListener("turbo:frame-load", this.boundFrameLoad)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    this.element.removeEventListener("turbo:frame-load", this.boundFrameLoad)
  }

  // Only a frame that actually carries a panel opens the drawer — the fresh, empty
  // frame streamed in after a save must stay closed.
  onFrameLoad(event) {
    if (event.target.children.length > 0) this.open()
  }

  open() {
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-x-full")
  }

  close() {
    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("translate-x-full")
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
